import { render } from "./TableLists.vue?vue&type=template&id=44ce83d8&scoped=true"
import script from "./TableLists.vue?vue&type=script&lang=js"
export * from "./TableLists.vue?vue&type=script&lang=js"

import "./TableLists.vue?vue&type=style&index=0&id=44ce83d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ce83d8"]])

export default __exports__